export default class Schema {
  /**
   * Notice: `inTable` and `editable` is true by default
   * @param {object} options - Schema options
   */
  constructor({
    inTable = true,
    editable = true,
    asFilter = false,
    asTabFilter = false,
    sortable = false,
    hide = false,
    render = null
  } = {}) {
    this.inTable = inTable
    this.editable = editable
    this.asFilter = asFilter
    this.asTabFilter = asTabFilter
    this.sortable = sortable
    this.hide = hide
    this.render = render
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/Schema.js